import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "./Tooltip.js";
const box = { "aria-hidden": true, style: { flex: "none" } };
function Glyph({ state }) {
    if (state === "active") {
        return (_jsx("svg", { "data-glyph": "person-active", width: 14, height: 14, viewBox: "0 0 14 14", ...box, children: _jsx("circle", { cx: 7, cy: 7, r: 5, fill: "currentColor" }) }));
    }
    if (state === "pending") {
        return (_jsx("svg", { "data-glyph": "person-pending", width: 14, height: 14, viewBox: "0 0 14 14", ...box, children: _jsx("circle", { cx: 7, cy: 7, r: 4.6, fill: "none", stroke: "currentColor", strokeWidth: 1.6 }) }));
    }
    if (state === "problem") {
        // 24-unit lucide geometry drawn at 16px; stroke 2.25 units is 1.5px (design-spec §4).
        return (_jsxs("svg", { "data-glyph": "person-problem", width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round", strokeLinejoin: "round", ...box, children: [_jsx("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }), _jsx("path", { d: "M12 9v4" }), _jsx("path", { d: "M12 17h.01" })] }));
    }
    return null;
}
const QUIET = new Set(["pending", "deactivated", "notsetup"]);
/** design-spec §4 Problem trigger: dotted `--ink-3`, thickness 1.5, offset 4. */
const DOTTED = {
    textDecorationLine: "underline", textDecorationStyle: "dotted", textDecorationColor: "var(--ink-3)",
    textDecorationThickness: "1.5px", textUnderlineOffset: "var(--space-05)",
};
export function PersonStateMark({ state, children, detail, tip }) {
    const tipped = state === "problem" && tip !== undefined;
    const mark = (_jsxs("span", { style: {
            display: "inline-flex", alignItems: "center", gap: "var(--space-1)",
            fontSize: "var(--type-body-size)", lineHeight: "var(--type-row-title-line)",
            fontWeight: state === "problem" ? "var(--type-body-weight-strong)" : "var(--type-body-weight)",
            whiteSpace: "nowrap",
        }, children: [_jsx(Glyph, { state: state }), _jsx("span", { "data-person-state-word": "", style: tipped ? DOTTED : undefined, children: children })] }));
    return (_jsxs("span", { "data-person-state": state, style: { display: "block", color: QUIET.has(state) ? "var(--ink-2)" : "var(--ink-1)" }, children: [tipped ? (_jsx(Tooltip, { title: tip.title, detail: tip.detail, children: mark })) : (mark), detail != null && (_jsx("span", { "data-person-state-detail": "", style: {
                    display: "block", color: "var(--ink-2)", paddingLeft: "calc(14px + var(--space-1))",
                    fontSize: "var(--type-small-size)", lineHeight: "var(--type-small-line)",
                    fontWeight: "var(--type-small-weight)",
                }, children: detail }))] }));
}
